var map = {
	"./section0.scss": 1589,
	"./section1.scss": 7013,
	"./section2.scss": 539,
	"./section3.scss": 3999,
	"./section4.scss": 468,
	"./section5.scss": 160,
	"./section6.scss": 1815,
	"./section7.scss": 3997,
	"./section8.scss": 3573,
	"./section9.scss": 4677,
	"./sectionDatenschutz.scss": 8847,
	"./sectionHome.scss": 8040,
	"./sectionImpressum.scss": 2500,
	"./sectionKontakt.scss": 1150,
	"./sectionMethoden.scss": 706,
	"./sectionNav.scss": 699
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8750;